import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Permission } from '../models/permissions';
import { PermissionsService } from '../services/permissions.service';

export const hasPermissions: CanActivateFn = (route) => {
  const permissionsService = inject(PermissionsService);
  const router = inject(Router);
  const requiredPermissions: Permission[] = route.data['permissions'] || [];

  const hasPermissions = permissionsService.hasPermissions(requiredPermissions)();
  return hasPermissions || router.parseUrl('/access-restricted');
};
